import { SPage } from "servisofts-component";
import list from "./list";
import _new from "./_new";
import edit from "./edit";

import Model from "../../../Model";

const model = Model.popup_inicio;
export const Parent = {
    name: "popup_inicio",
    path: `/marketing/popup_inicio`,
    model
}
export default SPage.combinePages(Parent.name, {
    "": list,
    "list": list,
    "new": _new,
    "edit": edit,
})
